module.exports = __webpack_public_path__ + "img/13.f981b2ef.jpg";